import * as React from "react";

type Project = {
  name: string;
  tagline: string;
  description: string;
  href: string;
  external?: boolean;
};

const projects: Project[] = [
  {
    name: "Aegis Vol",
    tagline: "News-aware volatility intelligence",
    description:
      "Transforms corporate news and SEC filings into auditable options trading decisions. Deterministic scoring, LLM-assisted analysis, and broker-agnostic trade intents with risk guardrails.",
    href: "/aegis-vol",
  },
  {
    name: "Incomash",
    tagline: "Digital credit income dashboard",
    description:
      "Track your STRC and SATA holdings in one clear view — portfolio value, live prices, and projected monthly and annual dividend income. Model different allocations with an interactive rebalancing slider and configurable yield assumptions.",
    href: "https://huskly.github.io/incomash/",
    external: true,
  },
  {
    name: "FX Tracker",
    tagline: "Open positions and realized P&L",
    description:
      "A lightweight tracker for foreign exchange positions with FIFO realized-lot accounting. Keep tabs on open exposure and realized gains across currency pairs.",
    href: "https://huskly.github.io/fx-tracker/",
    external: true,
  },
];

const Projects = () => (
  <section id="projects" className="border-t border-stone-200 bg-white">
    <div className="max-w-6xl mx-auto px-6 sm:px-10 py-24 sm:py-32 grid grid-cols-1 lg:grid-cols-12 gap-12">
      <div className="lg:col-span-3">
        <p className="text-xs uppercase tracking-[0.2em] text-stone-500">
          Projects
        </p>
        <h2 className="mt-4 font-serif text-3xl sm:text-4xl text-stone-900 leading-tight">
          What we're building.
        </h2>
      </div>
      <div className="lg:col-span-9 space-y-4">
        {projects.map((p) => (
          <a
            key={p.name}
            href={p.href}
            {...(p.external ? { target: "_blank", rel: "noreferrer" } : {})}
            className="group block rounded-xl border border-stone-200 bg-stone-50 p-8 sm:p-10 hover:border-stone-400 hover:bg-white transition-colors"
          >
            <div className="flex items-start justify-between gap-6">
              <div>
                <h3 className="font-serif text-2xl sm:text-3xl text-stone-900">
                  {p.name}
                </h3>
                <p className="mt-2 text-sm uppercase tracking-wider text-stone-500">
                  {p.tagline}
                </p>
                <p className="mt-5 text-base sm:text-lg text-stone-700 leading-relaxed max-w-2xl font-light">
                  {p.description}
                </p>
              </div>
              <span
                aria-hidden
                className="text-stone-400 group-hover:text-stone-900 transition-colors mt-2 text-2xl"
              >
                →
              </span>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default Projects;
